import { useState, useEffect, useContext } from 'react'
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer'
import { BarPlot } from '@mui/x-charts/BarChart'
import { ChartsGrid } from '@mui/x-charts/ChartsGrid'
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis'
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis'
import { ChartsReferenceLine } from '@mui/x-charts/ChartsReferenceLine'
import { Box } from '@mui/material'

import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'

export default function Charts() {
  const { dashboard } = useContext(DataContext)
  const [series, setSeries] = useState([] as any[])
  const seriesData = dashboard?.hotwater?.chart?.series
  useEffect(() => {
    setSeries([{ type: 'bar', data: seriesData, color: '#006ff4' }])
  }, [seriesData])

  return (
    <Box width={{
          xs:'98%', 
          sm:'280px', 
          md:'340px', 
          lg:'340px' 
        }}
        display="flex" 
        pt={custom.spacing.sm} 
        id="hotwaterChart">
      <ResponsiveChartContainer
        series={series}
        xAxis={[{ 
          data: dashboard?.hotwater?.chart?.xAxisLabels, 
          scaleType: 'band', id: 'x-axis-id' }]}
        height={200}
        margin={{
          left: 40,
          right: 50,
          top: 10,
          bottom: 30,
        }}>
          
        <BarPlot />
        <ChartsGrid horizontal={true} />
        <ChartsXAxis position="bottom" axisId="x-axis-id" 
            disableTicks={true} tickLabelPlacement="tick" 
            tickInterval={['12am','4',
              dashboard?.hotwater?.morningPeakFrom,
              dashboard?.hotwater?.morningPeakTo,
              '1pm','3 ',
              dashboard?.hotwater?.eveningPeakFrom,
              dashboard?.hotwater?.eveningPeakTo
              ,'11 ']} />
        <ChartsYAxis position="right" 
            disableTicks={true} tickLabelPlacement="tick" 
            tickInterval={[0,1,2,3,4,5]}
            valueFormatter={dashboard?.hotwater?.formatter}/>
        <ChartsReferenceLine
          label="Peak"
          spacing={{ x: 5, y: 15 }}
          labelStyle={{ fontFamily: 'GT Pressura Regular', 
                fontSize: '10px', color: 'sz.colors.gray100' }}
          labelAlign="start"
          x={dashboard?.hotwater?.morningPeakFrom}
          lineStyle={{ strokeDasharray: '10 5', strokeWidth: '1', 
                strokeOpacity: 0.3 }}
        />
        <ChartsReferenceLine
          spacing={{ x: 2, y: -15 }}
          labelStyle={{ fontFamily: 'GT Pressura Regular', 
                fontSize: '10px', color: 'colors.gray100' }}
          labelAlign="start"
          x={dashboard?.hotwater?.morningPeakTo}
          lineStyle={{ strokeDasharray: '10 5', strokeWidth: '1', 
                strokeOpacity: 0.3 }}
        />
        <ChartsReferenceLine
          label="Peak"
          spacing={{ x: 5, y: 15 }}
          labelStyle={{ fontFamily: 'GT Pressura Regular', 
              fontSize: '10px', color: 'sz.colors.gray100' }}
          labelAlign="start"
          x={dashboard?.hotwater?.eveningPeakFrom}
          lineStyle={{ strokeDasharray: '10 5', strokeWidth: '1', 
            strokeOpacity: 0.3 }}
        />
        <ChartsReferenceLine x={dashboard?.hotwater?.eveningPeakTo} lineStyle={{ 
            strokeDasharray: '10 5', strokeWidth: '1', strokeOpacity: 0.3 }} />
      </ResponsiveChartContainer>
    </Box>
  )
}
